<template>
  <date-picker
    v-model="model"
    prefix-class="datetime"
    range
    :type="type"
    value-type="format"
    :format="
      type == 'datetime'
        ? 'YYYY-MM-DD HH:mm:ss'
        : type == 'time'
        ? 'HH:mm:ss'
        : 'YYYY-MM-DD'
    "
    :shortcuts="$consts.dateTimeRangeShortcuts"
    :show-time-panel="showTimePanel"
    @close="showTimePanel = false"
    @change="changeModel()"
  >
    <template v-slot:header> <slot name="header"></slot> </template>
    <!-- <template v-slot:sidebar> sidebar </template> -->
    <template v-slot:input>
      <v-text-field
        v-model="text"
        :single-line="singleLine"
        :dense="dense"
        :hide-details="hideDetails"
        :label="label"
        :prepend-icon="
          hideIcon ? '' : type == 'time' ? 'fa-clock' : 'fa-calendar-week'
        "
        @blur="text = model.join(' ~ ')"
      ></v-text-field>
    </template>
    <template v-slot:icon-calendar>
      <v-icon></v-icon>
    </template>
    <template v-slot:icon-clear>
      <v-icon v-if="!removeIcon">fa-times</v-icon>
      <v-icon v-else></v-icon>
    </template>
    <template v-slot:footer v-if="type == 'datetime'">
      <button
        class="mx-btn mx-btn-text"
        @click="showTimePanel = !showTimePanel"
      >
        {{
          showTimePanel
            ? $t("$datetime.select_date")
            : $t("$datetime.select_time")
        }}
      </button>
    </template>
  </date-picker>
</template>

<script>
import i18n from "@/i18n";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "./datetime.scss";

if (i18n.locale == "zhHans") require("vue2-datepicker/locale/zh-cn");

const regDate =
  /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) ~ [1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
const regTime =
  /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d ~ (20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
const regDatetime =
  /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d ~ [1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;

export default {
  name: "DatetimeRangePicker",

  components: { DatePicker },

  props: {
    value: Array,
    label: String,
    type: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    hideIcon: Boolean,
    selectRange: String,
    removeIcon:Boolean,
  },

  data: () => ({
    showTimePanel: false,
    model: [],
    text: "",
  }),

  methods: {
    changeModel() {
      if (this.selectRange == "sameMonth") {
        let startDate = new Date(this.model[0]); // 取所选的起始日期
        let year = startDate.getFullYear(); // 取所选起始日期的所在年份
        const startMonth = startDate.getMonth() + 1; // 取所选起始日期的所在月份
        // const firstDate = new Date(year + "/" + startMonth + "/" + 2); // 取所选起始日期的所在月份的第一天日期
        let nextMonth = startMonth + 1;
        if (nextMonth === 13) {
          year += 1;
          nextMonth = 1;
        }
        const startDateLong =
          new Date(year + "/" + nextMonth + "/" + 2).getTime() -
          24 * 60 * 60 * 1000;
        const startDateEnd = new Date(startDateLong); // 取所选起始日期的所在月份的最后一天日期

        let endDate = new Date(this.model[1]); // 取所选的末尾日期
        const endMonth = endDate.getMonth() + 1; // 取所选末尾日期的所在月份
        if (endMonth != startMonth) {
          this.model[1] =
            startDateEnd.toISOString().substr(0, 10) + " 23:59:59";
          this.$emit("changedModel", true)
        }
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      immediate: true, //初始赋值也调用
      handler() {
        this.text = this.model.join(" ~ ");
        this.$emit("input", this.model);
      },
    },
    text: {
      handler() {
        var regExp =
          this.type == "datetime"
            ? new RegExp(regDatetime)
            : this.type == "date"
            ? new RegExp(regDate)
            : new RegExp(regTime);
        if (regExp.test(this.text)) {
          this.model = this.text.split(" ~ ");
        }
      },
    },
  },
};
</script>
